/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');

var EntityOfficerChangeApplication = require('../forms/EntityOfficerChangeApplication');

var GetEntityOfficer = require('../../entity-dashboard/services/GetEntityOfficer');
var GetAllEntityOfficerTypes = require('../../entity-form/services/GetAllEntityOfficerTypes');
var GetEntityOfficerChangeApplication = require('../services/GetEntityOfficerChangeApplication');
var GetEntityDetails = require('../../entity-form/services/GetEntityDetails');

module.exports = {
  event: 'build:amendment:entity-officer-change',

  channel: 'nd:application',

  builder: function(config) {
    var defer = $.Deferred();
    $.when(GetAllEntityOfficerTypes(), GetEntityOfficerChangeApplication(config.applicationId)).done(function(
      officerTypes,
      officer
    ) {
      $.when(GetEntityOfficer(officer.entityOfficerId), GetEntityDetails(officer.entityId)).done(function(
        oldOfficer,
        entityDetails
      ) {
        defer.resolve(
          new EntityOfficerChangeApplication({
            model: new Backbone.Model({
              officer: officer,
              oldOfficer: oldOfficer,
              officerTypes: officerTypes,
              applicationId: officer.applicationId,
              entityId: officer.entityId,
              isOfficerConvicted: officer.isOfficerConvicted,
              isCertified: officer.isCertified,
              certificationName: officer.certificationName,
              isOfficerConvictedDocument: officer.isOfficerConvictedDocument,
              oldIsOfficerConvicted: entityDetails.isOfficerConvicted,
              oldIsOfficerConvictedDocument: entityDetails.isOfficerConvictedDocument
            }),
            isReadOnly: config.isReadOnly,
            viewMode: config.viewMode,
            mode: config.mode,
            isAmendment: true
          })
        );
      });
    });
    return defer.promise();
  }
};
